import React, { useEffect, useRef, useState } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import PropTypes from 'prop-types';

const CustomMultiSelect = ({ 
    value, 
    options, 
    onChange, 
    onButtonClick, 
    optionLabel, 
    dataKey, 
    className, 
    style, 
    placeholder, 
    maxSelectedLabels = 1,
    itemTemplate,
    filter = false
}) => {
    const containerRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [intermediateValue, setIntermediateValue] = useState(value);

    const containerStyle = {
        padding: '0.5rem 0.5rem',
        display: 'inline-block',
    };

    const handleFocus = (e) => {
        e.preventDefault();
        setIsOpen(true);
    };

    const handleBlur = () => {
        if (isOpen) {
            setIsOpen(false);
            triggerFilterChange();
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === 'Tab') {
            triggerFilterChange();
        }
    };

    const triggerFilterChange = () => {
        // Trigger the parent change only if the value has changed
        if (JSON.stringify(intermediateValue) !== JSON.stringify(value)) {
            console.log(JSON.stringify(intermediateValue) + ' !== ' + JSON.stringify(value));
            onChange(intermediateValue);
        }
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            const isInsideContainer = containerRef.current && containerRef.current.contains(e.target);
            const isInsidePanel = e.target.closest('.p-multiselect-panel'); // Check if clicked inside the MultiSelect panel

            if (isOpen && !isInsideContainer && !isInsidePanel) {
                setIsOpen(false);
                triggerFilterChange();
                onButtonClick(true);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, intermediateValue]);

    return (
        <div ref={containerRef} style={containerStyle}>
            <MultiSelect
                value={intermediateValue}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
                onChange={(e) => setIntermediateValue(e.value)} // Update intermediate value only
                className={className}
                optionLabel={optionLabel}
                dataKey={dataKey}
                style={style}
                options={options}
                placeholder={placeholder}
                maxSelectedLabels={maxSelectedLabels}
                itemTemplate={itemTemplate}
                filter={filter}
            />
        </div>
    );
};

CustomMultiSelect.propTypes = {
    value: PropTypes.array,
    options: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    onButtonClick: PropTypes.func,
    optionLabel: PropTypes.string,
    dataKey: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    placeholder: PropTypes.string,
    maxSelectedLabels: PropTypes.number,
    itemTemplate: PropTypes.func,
    filter: PropTypes.bool
}

export default CustomMultiSelect;
